module.exports = __webpack_public_path__ + "img/icon_weixin@2x.342eb478.png";